<template>
  <div>
    <div style="display: inline-flex;">
      <h6>{{ dispProductCount }} {{ dispInboundCount }} {{ dispPackedCount }} {{ dispTotalPurchaseAmount }} {{ dispTotalInboundAmount }}</h6>
    </div>
    <div v-if="showCsv" class="margin-left-4" style="display: inline-flex;">
      <button type="button" @click="$emit('outputCsv', $event)" class="btn btn-danger btn-sm">通常商品CSV</button>
      <button type="button" @click="$emit('outputSetCsv', $event)" class="btn margin-left btn-primary btn-sm">セット商品CSV</button>
      <button type="button" @click="$emit('outputPastCsv')" class="btn margin-left btn-danger btn-sm">発送済CSV</button>
    </div>
    <div v-if="showCsv" class="margin-left-4" style="display: inline-flex;">
      <span class="warn-deposit left-margin">
        <b-input-group size="sm" prepend="Point(本日)">
          <b-input class="group-label_4" :value="slcAnalysisPointToday"/>
        </b-input-group>
      </span>
      <span class="warn-deposit left-margin">
        <b-input-group size="sm" prepend="Point累計">
          <b-input class="group-label_4" :value="slcAnalysisPointAll"/>
        </b-input-group>
      </span>
      <span class="warn-deposit left-margin">
        <b-input-group size="sm" prepend="デポジット残">
          <b-input class="group-label_6" :value="dispDeposit"/>
        </b-input-group>
      </span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    items: { default: [] },
    showCsv: { default: false },
    inboundPoint: { default: '120' },
    deposit: { default: 0 },
    slcAnalysisPointToday: {
      default: 0,
    },
    slcAnalysisPointAll: {
      default: 0,
    }
  },
  computed: {
    productCount() { return this.items.length; },
    inboundCount() { return this.items.reduce( (a, v) => a += utility.toNumber(v['purchaseQuantity']), 0); },
    packingCount() { return this.items.reduce( (a, v) => a += utility.toNumber(v['inboundQuantity']), 0); },
    unPackingCount() { return this.items.reduce( (a, v) => a += utility.toNumber(v['unInboundQuantity']), 0); },
    dispDeposit() {
      return this.formatPrice(this.deposit);
    },
    totalPurchaseAmount() {
      if (this.items.length === 0){
         return 0;
      }
      var total = 0;
      for (var i=0; i<this.items.length; i++){
         if(this.items[i]['delete']){
           continue;
         }
         total += this.items[i]['purchaseUnitPrice'] * utility.toNumber(this.items[i]['purchaseQuantity']);
       }
       return total;
    },
    totalInboundAmount() {
      if (this.items.length === 0){
         return 0;
      }
      var total = 0;
      for (var i=0; i<this.items.length; i++){
         if(this.items[i]['delete']){
           continue;
         }
         total += this.items[i]['purchaseUnitPrice'] * utility.toNumber(this.items[i]['inboundQuantity']);
       }
       return total;
    },
    dispProductCount() {
      return '[ 表示 ] ' + this.productCount + '件　　';
    },
    dispInboundCount() {
      return '[ 購入数 ] ' + this.inboundCount + '個　　';
    },
    dispPackedCount() {
      return '[ 入庫数 ] ' + this.packingCount + '個　　';
    },
    dispTotalPurchaseAmount(){
      return '[ 合計購入金額 ] ' + this.formatPrice(this.totalPurchaseAmount) + '　　';
    },
    dispTotalInboundAmount(){
      return '[ 合計入庫金額 ] ' + this.formatPrice(this.totalInboundAmount);
    }
  },
};
</script>

<style>
.left-margin {
  padding-left: 15px;
}
.group-label {
  pointer-events: none;
  width: 7rem!important;
  text-align: right;
}
.margin-left {
    margin-left: 1rem;
}
.margin-left-4 {
    margin-left: 4rem;
}
.warn-deposit .input-group-text{
  background-color: red;
  color: white;
  border-color: red;
}
.warn-deposit .form-control{
  border-color: red;
}
.group-label_4 {
  pointer-events: none;
  width: 4rem!important;
  text-align: right;
}
.group-label_6 {
  pointer-events: none;
  width: 6rem!important;
  text-align: right;
}
</style>
